/**********************
 * CREATE OR UPDATE VIDEO GROUP MODAL
 *********************/
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import { Select, Input as AntdInput, Form as AntdForm } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import * as Yup from "yup"
import { useFormik } from "formik"
import { acCreateUpdateGroup } from "helpers/backend_helper"
import { showToast } from "utils/general"

const VideoGroupModal = props => {
  const [ongoingAction, setOngoingAction] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      groupId: props.groupData?.group_id || undefined,
      parentId: props.groupData?.parent_id || undefined,
      name: props.groupData?.name || "",
      groupType: props.groupData?.group_type || "25",
      production: props.production,
    },
    validationSchema: Yup.object({
      parentId: Yup.string().required(),
      name: Yup.string()
        .required(props.t("Required field"))
        .trim()
        .min(3, props.t("Too short"))
        .max(36, props.t("Too long")),
    }),
    onSubmit: values => {
      console.log("Submit group: ", values)
      if (!ongoingAction) {
        setOngoingAction(true)
        acCreateUpdateGroup(
          abortRef.current,
          values.parentId,
          values.name,
          values.groupType,
          values.groupId,
          values.production
        )
          .then(result => {
            if (result.statusCode == 200) {
              if (props.setShowModal) {
                props.setShowModal(false)
              }
              if (props.refreshGroups) {
                props.refreshGroups()
              }
            } else throw new Error("Unexpeced result")
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error")
          })
          .finally(() => {
            setOngoingAction(false)
          })
      }
    },
  })

  return (
    <>
      <Modal
        isOpen={props.showModal}
        toggle={() => {
          if (props.setShowModal) {
            props.setShowModal(!props.showModal)
          }
        }}
        centered
      >
        <div className="modal-header">
          {validation.values.groupId ? (
            <h5 className="modal-title mt-0">{props.t("Edit group")}</h5>
          ) : (
            <h5 className="modal-title mt-0">{props.t("Add subgroup")}</h5>
          )}
          <button
            type="button"
            onClick={() => {
              if (props.setShowModal) {
                props.setShowModal(false)
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              return false
            }}
          >
            <FormGroup>
              <Label>{props.t("Name")}</Label>
              <AntdForm.Item validateStatus={validation.errors.name ? "error" : ""} hasFeedback help={validation.errors.name}>
                <AntdInput
                  allowClear
                  placeholder={props.t("Name")}
                  value={validation.values.name}
                  onChange={(v) => { validation.setFieldValue("name", v.target.value) }}
                />
              </AntdForm.Item>
            </FormGroup>
            <FormGroup>
              <Label>{props.t("Type")}</Label>
              <Select
                value={validation.values.groupType}
                placeholder={props.t("Choose")}
                onChange={(v) => { validation.setFieldValue("groupType", v) }}
                options={[
                  { label: props.t("Undefined"), value: "0" },
                  { label: props.t("Company"), value: "1" },
                  { label: props.t("Regular group"), value: "5" },
                  { label: props.t("Homecare users"), value: "9" },
                  { label: props.t("Family"), value: "10" },
                  { label: props.t("Family members"), value: "11" },
                  { label: props.t("Visibility list"), value: "15" },
                  { label: props.t("Professionals"), value: "16" },
                  { label: props.t("Service center staff"), value: "17" },
                  { label: props.t("Visibility list for professionals"), value: "19" },
                  { label: props.t("Visibility list for homecare users"), value: "20" },
                  { label: props.t("Visibility list for family members"), value: "21" },
                  { label: props.t("Visibility list for guests"), value: "22" },
                  { label: props.t("Content visibility list"), value: "25" },
                ]}
                style={{ width: 100 + "%" }}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="p-2 mt-2">
          <Col lg={12} className="mt-2 mb-0  text-truncate">
            <Row>
              <Col xs={12}>
                <span className="float-end">
                  <button
                    type="button"
                    onClick={() => {
                      if (props.setShowModal) {
                        props.setShowModal(false)
                      }
                    }}
                    className="btn btn-outline-primary "
                    data-dismiss="modal"
                  >
                    {props.t("Cancel")}
                  </button>

                  <button
                    disabled={ongoingAction || !validation.values.name}
                    className="btn btn-primary ms-2"
                    onClick={() => {
                      validation.submitForm()
                    }}
                  >
                    {props.t("Save")}
                  </button>
                </span>
              </Col>
            </Row>
          </Col>
        </ModalFooter>
      </Modal>
    </>
  )
}

VideoGroupModal.propTypes = {
  t: PropTypes.any,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  refreshGroups: PropTypes.func,
  groupData: PropTypes.any,
  production: PropTypes.bool,
}

export default withTranslation()(VideoGroupModal)
